import CustomToast from "@/lib/custom-toast";
import { useAuth } from "common/hooks";
import { toast } from "react-toastify";

export function useCustomToast() {
  const { logout } = useAuth();
  const showToast = (message: string, type: "error" | "success" | "normal") => {
    if (message === "Failed to refresh token. Please perform the login!") {
      //logout
      logout();
    }

    toast(
      <CustomToast
        message={message}
        onClose={() => toast.dismiss()}
        type={type}
      />,
      {
        //className:"toast-body", // Custom class to override padding
        //bodyClassName:"toast-body", // Custom class to override body margin
        progressClassName: "no-progress", // Custom class to remove progress bar
        hideProgressBar: true, // Hide the progress bar
        closeOnClick: false,
        closeButton: false,
        style: {
          padding: "0px",
          margin: "0px",
          border: 2,
          borderTopColor: "red",
          borderRadius: 12,
        },
      },
    );
  };
  return showToast;
}
